import React, { useState } from 'react';
const valueBreakdown = [{
  label: 'Percorso Didattico (6 Volumi 1ª–5ª)',
  value: '€97'
}, {
  label: 'Verifiche editabili & Rubriche',
  value: '€57'
}, {
  label: 'Esperimenti Laboratorio Impossibile',
  value: '€47'
}, {
  label: '6 Bonus Esclusivi',
  value: '€49'
}];
const trustBadges = [{
  icon: '🔒',
  title: 'Pagamento Sicuro',
  sub: 'Crittografia SSL 256-bit'
}, {
  icon: '🛡️',
  title: 'Garanzia 7 Giorni',
  sub: 'Soddisfatti o rimborsati'
}, {
  icon: '✅',
  title: 'Acquisto Verificato',
  sub: '+1.500 docenti soddisfatti'
}];
const paymentMethods = ['VISA', 'Mastercard', 'AMEX', 'Apple Pay', 'Google Pay'];
const MAIN_URL = 'https://italia.edulabs.online/cart/43454242029686:1';
const COMBO_URL = 'https://italia.edulabs.online/cart/43454244716662:1';
export function PricingSection() {
  const [addCombo, setAddCombo] = useState(false);
  const finalPrice = addCombo ? 29 : 19;
  const checkoutUrl = addCombo ? COMBO_URL : MAIN_URL;
  const ctaLabel = addCombo ? `🚀 SÌ! VOGLIO IL COMBO — € ${finalPrice}` : `🚀 SÌ! VOGLIO FISICA PRONTA — € ${finalPrice}`;
  return <section id="pricing" aria-label="Prezzi e offerte" className="bg-brand-dark py-8 md:py-28 px-4 border-t border-brand-border" data-id="element-185">
      <div className="max-w-xl mx-auto" data-id="element-186">
        {/* Title */}
        <div className="text-center mb-4 md:mb-10" data-id="element-187">
          <h2 className="text-2xl md:text-5xl font-heading font-black text-white leading-tight" data-id="element-188">
            L'Offerta <span className="text-brand-accent" data-id="element-189">"Fisica Pronta"</span>
          </h2>
        </div>

        {/* Main Offer Card */}
        <div className="relative bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-4 md:p-8 shadow-[0_0_40px_rgba(0,255,133,0.08)]" data-id="element-190">
          {/* Popular Badge */}
          <div className="flex justify-center -mt-9 md:-mt-12 mb-3 md:mb-6" data-id="element-191">
            <div className="bg-brand-accent text-brand-dark font-black text-[10px] md:text-sm uppercase tracking-widest px-4 md:px-5 py-1.5 md:py-2 rounded-full shadow-lg flex items-center gap-2" data-id="element-192">
              ⭐ LA SCELTA PIÙ POPOLARE
            </div>
          </div>

          {/* Value Breakdown */}
          <div className="mb-2" data-id="element-193">
            <h3 className="text-xs md:text-lg font-heading font-black text-white uppercase tracking-wider mb-2.5 md:mb-5" data-id="element-194">
              VALORE TOTALE DEI CONTENUTI:
            </h3>
            <div className="space-y-1.5 md:space-y-3.5" data-id="element-195">
              {valueBreakdown.map((item, i) => <div key={i} className="flex items-center justify-between text-xs md:text-base" data-id="element-196">
                  <span className="text-white/80" data-id="element-197">{item.label}</span>
                  <span className="text-white/40 line-through font-medium whitespace-nowrap pl-3" data-id="element-198">
                    {item.value}
                  </span>
                </div>)}
              <div className="border-t border-brand-border pt-2 md:pt-4 mt-2 flex items-center justify-between" data-id="element-199">
                <span className="text-white font-heading font-black uppercase tracking-wider text-xs md:text-lg" data-id="element-200">
                  Valore Reale:
                </span>
                <span className="text-[#FF4D33] line-through font-heading font-black text-base md:text-2xl" data-id="element-201">
                  € 250
                </span>
              </div>
            </div>
          </div>

          {/* Big Price Box */}
          <div className="mt-3 md:mt-6 mb-3 md:mb-5 bg-brand-dark border border-brand-border rounded-xl md:rounded-2xl p-3 md:p-8 text-center" data-id="element-202">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-1 md:mb-3" data-id="element-203">
              <span className="text-white/40 line-through font-medium text-xs md:text-lg" data-id="element-204">
                € 250
              </span>
              <span className="bg-brand-accent/20 text-brand-accent font-black text-[9px] md:text-xs px-2 md:px-2.5 py-0.5 md:py-1 rounded-full uppercase tracking-wider" data-id="element-205">
                {addCombo ? '89% OFF' : '92% OFF'}
              </span>
            </div>
            <div className="text-brand-accent font-heading font-black text-5xl md:text-7xl leading-none mb-1 md:mb-3 tracking-tight transition-all" data-id="element-206">
              € {finalPrice}
            </div>
            <div className="text-white/70 text-[10px] md:text-sm font-medium flex flex-wrap items-center justify-center gap-x-2 md:gap-x-3 gap-y-1" data-id="element-207">
              <span data-id="element-208">💳 Pagamento unico</span>
              <span className="text-white/30" data-id="element-209">•</span>
              <span data-id="element-210">⚡ Accesso immediato</span>
            </div>
          </div>

          {/* Urgency Pill */}
          <div className="flex justify-center mb-3 md:mb-5" data-id="element-211"></div>

          {/* ORDER BUMP — Chimica Pronta */}
          <label htmlFor="bump-chimica" className={`relative block mb-3 md:mb-5 cursor-pointer rounded-xl md:rounded-2xl p-3 md:p-5 border-2 border-dashed transition-all ${addCombo ? 'border-brand-accent bg-brand-accent/10' : 'border-brand-accent/40 bg-brand-dark hover:border-brand-accent/70 hover:bg-brand-accent/5'}`} data-id="element-212">
            {/* Top hook badge */}
            <div className="absolute -top-3 md:-top-3.5 left-4 md:left-6 bg-[#FFB020] text-brand-dark font-black text-[10px] md:text-xs uppercase tracking-widest px-3 md:px-4 py-1 md:py-1.5 rounded-full shadow-[0_4px_14px_rgba(255,176,32,0.4)] flex items-center gap-1.5" data-id="element-213">
              <span aria-hidden="true" data-id="element-214">🔥</span>
              <span data-id="element-215">7 docenti su 10 lo aggiungono</span>
            </div>
            <div className="flex items-start gap-2.5 md:gap-3 pt-1.5 md:pt-2" data-id="element-216">
              {/* Custom checkbox */}
              <div className="flex-shrink-0 pt-0.5" data-id="element-217">
                <input id="bump-chimica" type="checkbox" checked={addCombo} onChange={e => setAddCombo(e.target.checked)} className="sr-only" data-id="element-218" />
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-md border-2 flex items-center justify-center transition-colors ${addCombo ? 'border-brand-accent bg-brand-accent' : 'border-white/40 bg-transparent'}`} aria-hidden="true" data-id="element-219">
                  {addCombo && <svg className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-dark" viewBox="0 0 20 20" fill="currentColor" data-id="element-220">
                      <path fillRule="evenodd" d="M16.7 5.3a1 1 0 010 1.4l-7 7a1 1 0 01-1.4 0l-3-3a1 1 0 011.4-1.4L9 11.6l6.3-6.3a1 1 0 011.4 0z" clipRule="evenodd" data-id="element-221" />
                    </svg>}
                </div>
              </div>
              <div className="flex-grow min-w-0" data-id="element-222">
                <div className="flex items-start justify-between gap-2 mb-0.5 md:mb-1.5" data-id="element-223">
                  <div className="flex items-center gap-1.5 flex-wrap" data-id="element-224">
                    <span className="text-base md:text-xl leading-none" aria-hidden="true" data-id="element-225">
                      🧪
                    </span>
                    <span className="text-white font-heading font-black text-xs md:text-base leading-tight" data-id="element-226">
                      SÌ! Aggiungi{' '}
                      <span className="text-brand-accent" data-id="element-227">Chimica Pronta</span>
                    </span>
                  </div>
                  <div className="text-right flex-shrink-0 leading-none" data-id="element-228">
                    <div className="text-white/40 line-through text-[10px] md:text-xs font-medium" data-id="element-229">
                      €19
                    </div>
                    <div className="text-brand-accent font-heading font-black text-base md:text-xl" data-id="element-230">
                      +€10
                    </div>
                  </div>
                </div>
                <p className="text-white/80 text-[11px] md:text-sm leading-snug md:leading-relaxed mb-1.5 md:mb-2" data-id="element-231">
                  Completa il tuo set scientifico con{' '}
                  <span className="text-white font-bold" data-id="element-232">
                    6 volumi di Chimica + 120 lezioni
                  </span>
                  .{' '}
                  <span className="text-brand-accent font-bold" data-id="element-233">
                    Solo €1,66 per volume aggiuntivo.
                  </span>
                </p>
                <div className="flex items-start gap-1.5 text-[10px] md:text-xs text-white/70 italic leading-snug" data-id="element-234">
                  <span aria-hidden="true" data-id="element-235">⚠️</span>
                  <span data-id="element-236">
                    <span className="font-bold text-white not-italic" data-id="element-237">
                      Offerta esclusiva:
                    </span>{' '}
                    Risparmi il{' '}
                    <span className="text-brand-accent font-bold not-italic" data-id="element-238">
                      50% su Chimica
                    </span>{' '}
                    solo aggiungendola ora. Prezzo fuori da questa pagina:{' '}
                    <span className="line-through" data-id="element-239">€19</span>
                  </span>
                </div>
              </div>
            </div>
          </label>

          {/* Main CTA */}
          <button onClick={() => window.open(checkoutUrl, '_blank')} aria-label={`Acquista per €${finalPrice}`} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-sm md:text-xl py-4 md:py-6 rounded-xl md:rounded-2xl transition-all flex items-center justify-center gap-2 active:scale-[0.98] shadow-[0_8px_30px_rgba(0,255,133,0.25)] pt-[30px] pb-[30px]" data-id="element-240">
            {ctaLabel}
          </button>

          {/* Trust Badges Grid */}

          {/* Payment Methods */}
        </div>
      </div>
    </section>;
}